import { fromJS, List, Record } from 'immutable';
const PropertyValueRecord = Object.assign(Record({
  name: undefined,
  source: null,
  sourceId: null,
  timestamp: null,
  updatedByUserId: null,
  value: undefined,
  versions: List()
}, 'PropertyValueRecord'), {
  fromJS(json) {
    if (!json || typeof json !== 'object') {
      return json;
    }
    return PropertyValueRecord(fromJS(json)
    // TODO colby: disabling this for now until we can figure out how to handle
    // the different formats
    // .update(
    //   'versions',
    //   (versions) -> versions?.map(PropertyValueVersionRecord.fromJS) ? List()
    // )
    );
  }
});
export default PropertyValueRecord;